import { HttpClient, HttpHeaders } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { SmartQuote } from '../interfaces/smartquote.interface'
import { map, Observable } from 'rxjs'
import { environment } from 'projects/quoting-app/src/environments/environment'
import { ApiResponse } from 'projects/sf-quoting-lib/src/lib/interfaces/api-response.interface'

@Injectable({
    providedIn: 'root',
})
export class SmartquoteService {
    #httpClient = inject(HttpClient)

    getSmartquote(id: string): Observable<SmartQuote> {
        return this.#httpClient.get<ApiResponse<SmartQuote>>(`${environment.baseUrl}public/smartquote/${id}`).pipe(
            map(response => {
                return response.result
            })
        )
    }

    acceptSmartquote(id: string): Observable<any> {
        return this.#httpClient.post<ApiResponse<any>>(`${environment.baseUrl}public/smartquote/${id}/accept`, {})
    }

    downloadPdf(id: string): Observable<{ filename: string | null; data: Blob | object | null }> {
        const headers = new HttpHeaders().set('Accept', 'text/csv')
        return this.#httpClient
            .get(`${environment.baseUrl}public/smartquote/${id}/pdf`, {
                headers,
                responseType: 'blob',
                observe: 'response',
            })
            .pipe(
                map(response => {
                    return {
                        filename: response.headers.get('file-name'),
                        data: response.body,
                    }
                })
            )
    }
}
